import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MODAL_IDS } from '@/kit/Modal/keys';
import { useModal } from '@/providers/modal';
import Icon from './icon_circle.svg';
import s from './index.module.scss';

export const ReportFaqButton = ({ className }) => {
  const { t } = useTranslation('activity');
  const { openSingleModal } = useModal();
  return (
    <button
      type="button"
      className={classnames(s.button, className)}
      onClick={() => openSingleModal(MODAL_IDS.report_reference_modal)}
    >
      <img src={Icon} alt="info" width={20} height={20} />
      {className && <span>{t('reference_button.reference')}</span>}
    </button>
  );
};
